Librarian.Modules.Wizards = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-wizards-",
        id: "wizards",
        label: "Wizards",
        folderPath: "MasterLibrary/Wizards"
    },

    initialize: function (options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);

        var self = this;
        wrapperEl.addEvent("click", function() {
            Librarian.Utils.selectTreeNodeByPath(treeView, self.options.folderPath, null, true);
        });
    },

    load: function () {
        this.parent();

        var label = (this.options.label || '').trim();
        if (label.length > 0) {
            new Element("div", {
                "class": "nav-label",
                "html": Librarian.Lang.getString(label),
                "data-translation": label
            }).injectInside(this.containerEl);
        }
    }
});